import { useTheme } from '@emotion/react';
import { ArrowSquareOut, CircleNotch, Warning } from '@phosphor-icons/react';
import { EventType } from 'common/EventConstants';
import { useApi } from 'client/lib/trpc';
import { DropdownMenu } from 'client/components/DropdownMenu';

interface UseViewAppBlockerParams {
  deploymentID?: number | null;
  host?: string;
  href?: string | null;
}

export const useViewAppBlocker = ({ deploymentID, host = 'auto', href }: UseViewAppBlockerParams) => {
  const api = useApi();
  const theme = useTheme();

  const handleForceOpen = () => {
    if (deploymentID) {
      api.status.eventCreate.mutate({
        eventTypeID: EventType.DEPLOYMENT_HOST_OPEN,
        deploymentID,
        host,
        reason: 'force',
      });
    }
  };

  const menuItems = [
    <DropdownMenu.Banner
      title="Deployment is Starting"
      subtitle="This deployment is still starting up. The page displayed in the browser might not be ready yet."
      icon={<Warning color={theme.color.yellow[100]} />}
      ornament={<CircleNotch color={theme.color.yellow[100]} />}
      state="loading"
    />,
    {
      id: 'open',
      title: 'Open Anyway',
      subtitle: 'Open deployment URL',
      icon: <ArrowSquareOut />,
      href: href || undefined,
      external: true,
      onClick: handleForceOpen,
    },
  ];

  return { menuItems };
};
